"use client";

import { FloatingTrialBannerSlot } from "@/components/blocks/marketing/announcement-banners/floating-client";
import { TrialClaimProvider } from "@modules/saas/trial-claim/context";

/**
 * (main) 布局的内容壳(4.7):悬浮试用通知的挂载点。
 *
 * - 0.8.5 工单 08:TrialClaimProvider 全站挂载,三个试用入口(概览横幅/
 *   悬浮条/定价卡)共享同一弹窗与同一份资格状态;
 * - T05(2026-10-02 走查):预留条与悬浮条改由 **Provider 内部的**
 *   `FloatingTrialBannerSlot` 同源渲染——壳里看不到试用状态,原先在壳里
 *   算的 `showBanner` 只认 dismiss/consent,已绑卡/已付费/试用结束的账号
 *   会在页脚上方留一条 56/80px 空条。壳现在只负责 Provider 与列布局;
 * - SSR / 未 mounted 时无 padding、无横幅,children 原样输出。
 *   Nav / Footer / 页面内容仍是服务端组件,经 children 传入。
 */
export default function MainShell({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <TrialClaimProvider>
      <div className="relative z-10 flex min-h-[calc(100vh-64px)] flex-col">
        {children}
        <FloatingTrialBannerSlot />
      </div>
    </TrialClaimProvider>
  );
}
